<template>
    <v-app id="onMlhf">
        <v-main>
            <v-container fluid>  
                <v-card>
                    Nr: {{mlhf.mlhf_nr}} - {{mlhf.mlhf_oms}}  <v-btn text @click="mlhfView()">View</v-btn>  <v-btn text @click="mlhfViewTest()">View Test</v-btn> <v-btn class="primary ma-2" small @click="saveMlhf(mlhf)">Save</v-btn><br>
                    Language: {{mlhf.taal_oms}} <br>  
                    Countries: {{mlhf.land_oms}} <br>
                    <br>
                    <v-textarea v-model="mlhf.mlhf_header" :value=mlhf.mlhf_header rows="20" label="Production email Header"></v-textarea>
                    <br>
                
                    <v-textarea v-model="mlhf.mlhf_footer" :value=mlhf.mlhf_footer rows="20" label="Production email Footer"></v-textarea>
                    <br>
                    <br>
                
                    <v-textarea v-model="mlhf.mlhf_header_test" :value=mlhf.mlhf_header_test rows="20" label="Test email Header"></v-textarea>
                    <br>
                
                    <v-textarea v-model="mlhf.mlhf_footer_test" :value=mlhf.mlhf_footer_test rows="20" label="Test email Footer"></v-textarea>
                </v-card>  
            </v-container>
        </v-main>
        <navBar title="Ares - Mail templates" :home="true" type="mltp"/>
    </v-app>
</template>


<script>

    import navBar from "@/components/ui/navbars/navbar.vue"

    export default {
        components: {
            navBar
        },
        props: ['mlhf_encrid'],

        data() {
            return {
                mlhf: {}
            }  
        },
        mounted() {
            this.$axios.post("ares/json/ares/syst/mltp/getMlhf.p", {
                header: {
                    token: this.$session.get("ARES"),
                    clientSessionId: this.$session.id(),
                    request: "getMlhf"
                },
                getMlhf: {
                    mlhf_encrid: this.mlhf_encrid
                }
            }).then(res => {
                if (res.data.error) {
                    console.log(res.data.error);
                } else {
                    this.mlhf = res.data.getMlhf;
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        methods: {
            saveMlhf(mlhf) { 
                this.$axios.post("ares/json/ares/syst/mltp/saveMlhf.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "saveMlhf"
                    },
                    saveMlhf: {
                        mlhf: mlhf
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.saveMlhf.text,
                            color: res.data.saveMlhf.color
                        });
                    }
                })
            },
    
            mlhfView() {
                window.open(this.mlhf.mlhf_view,'_blank');
            },
            mlhfViewTest() {
                window.open(this.mlhf.mlhf_view_test,'_blank');
            }
        }  
    };
</script> 
